<template>
  <header class="main-header">
    <mobile-menu :social="social" :user="user"></mobile-menu>
    <div
      class="d-flex mobile-header d-md-none align-items-center justify-content-between"
    >
      <img
        src="@/assets/images/icons/infoDiagram-logo-sygnet.svg"
        alt="InfoDiagram Logo"
      />
      <Search />
      <button class="menu" @click.prevent="toggleSideMenu">
        <svg
          width="28"
          height="19"
          viewBox="0 0 28 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="open"
        >
          <path
            d="M0 19H28V15.8333H0V19ZM0 11.0833H28V7.91667H0V11.0833ZM0 0V3.16667H28V0H0Z"
            fill="#929292"
          ></path>
        </svg>
        <svg
          width="38"
          height="26"
          viewBox="0 0 38 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="close"
        >
          <path
            d="M0 25.1186H27.4444V20.9322H0V25.1186ZM0 14.6525H21.1111V10.4661H0V14.6525ZM0 0V4.18644H27.4444V0H0ZM38 20.074L30.4422 12.5593L38 5.04466L35.0233 2.09322L24.4678 12.5593L35.0233 23.0254L38 20.074Z"
            fill="#FFAA00"
          ></path>
        </svg>
      </button>
    </div>
    <div class="container-fluid header-inner">
      <div class="row">
        <div class="col-md-4 d-none d-md-block">
          <div>
            <router-link to="/panel/diagrams" @click.native="clearFiltering">
              <img
                src="@/assets/images/infodiagram-account.svg"
                style="display: block; width: 100%"
              />
            </router-link>
          </div>
        </div>
        <div class="col-md-8 d-none d-md-block">
          <div
            class="row align-items-center justify-content-end d-flex user-nav"
          >
            <div class="user-nav-item">
              <div class="d-flex align-items-center">
                <img src="@/assets/images/icons/user.svg" class="user-icon" />
                <my-profile-dropdown v-if="user" />
              </div>
            </div>
            <div class="user-nav-item">
              <my-credits v-if="user" />
            </div>
            <div class="">
              <get-credits-button v-if="user" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Navigation v-if="user" />
  </header>
</template>

<script>
import Search from 'components/Panel/Search.vue'
import MobileMenu from 'components/Layout/MobileMenu'
import { mapMutations, mapState } from 'vuex'
import Navigation from 'components/Layout/Navigation.vue'
import MyProfileDropdown from 'components/Panel/MyProfileDropdown.vue'
import MyCredits from 'components/Panel/MyCredits.vue'
import GetCreditsButton from 'components/Buttons/GetCreditsButton.vue'
export default {
  name: 'Header',
  components: {
    GetCreditsButton,
    MyCredits,
    MyProfileDropdown,
    MobileMenu,
    Navigation,
    Search
  },
  data () {
    return {
      social: [
        {
          title: 'Contact us',
          class: 'contact',
          url: `${process.env.WEBSITE_URL}contact.html`,
          target: false
        },
        {
          title: 'Our Sideshare presentations',
          class: 'slideshare',
          url: 'http://www.slideshare.net/infodiagram',
          target: '_blank'
        },
        {
          title: 'Follow us on Twitter',
          class: 'twitter',
          url: 'https://twitter.com/infodiagram',
          target: '_blank'
        },
        {
          title: 'Our Linkedin profile',
          class: 'linkedin',
          url: 'http://www.linkedin.com/company/infodiagram-com',
          target: '_blank'
        },
        {
          title: 'Check out pins we love',
          class: 'pinterest',
          url: 'http://www.pinterest.com/infodiagram/',
          target: '_blank'
        }
      ]
    }
  },
  methods: {
    ...mapMutations('filtering', ['clearFiltering']),
    ...mapMutations(['toggleMobileMenu']),
    toggleSideMenu () {
      this.toggleMobileMenu()
      if (this.mobileMenuActive) {
        document.body.classList.add('mobile-nav-open')
      } else {
        document.body.classList.remove('mobile-nav-open')
      }
    }
  },
  computed: {
    ...mapState(['user']),
    ...mapState(['mobileMenuActive'])
  }
}
</script>

<style lang="scss">
@use "sass:color";
.shadow {
  box-shadow: 2px 2px 0px rgba(0, 0, 0, 0.15);
}
.main-header {
  width: 100%;
  border-top: 2px solid #d9d9d9;
  .header-inner {
    padding-top: 14px;
    padding-bottom: 11px;
  }
  .user-icon {
    width: 30px;
    height: 30px;
  }
  .user-nav {
    flex: 1 1 auto;
    & > * {
      width: auto;
      max-width: auto;
    }
  }
  .user-nav-item,
  .user-nav-item .btn {
    font-size: 20px;
  }
  .get-credits {
    width: 100%;
    justify-content: center;
    min-width: 242px;
  }
  .logo {
    margin: 8px 0;
    cursor: pointer;
  }
  .main-menu {
    float: right;
    margin: 25px 0 16px;
    padding: 0;
    list-style: none;
    li {
      margin: 0 35px;
      &:last-child {
        margin-right: 0;
      }
      &.user {
        span {
          text-transform: capitalize;
        }
      }
      a {
        text-transform: uppercase;
        font-size: 16px;
        color: #474747;
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
  .account-nav {
    list-style-type: none;
    margin: 0;
    padding: 4px 0;
    li {
      display: inline-block;
      vertical-align: middle;
      &:after {
        content: '|';
        margin: 0px 10px;
      }
      &:last-child:after {
        display: none;
      }
      a,
      & > span {
        font-family: 'MuseoSans-300', sans-serif;
        display: inline-block;
        font-size: 14px;
        line-height: 17px;
        color: #913d88;
        text-decoration: none;
        span {
          text-transform: capitalize;
        }
      }
      a {
        border-bottom: 1px solid #913d88;
        &:hover {
          border-color: transparent;
        }
      }
    }
  }
}
.social {
  &-buttons {
    float: right;
    list-style-type: none;
    padding: 0;
    margin: 9px 0 0 0;
  }
  &-button {
    float: left;
    width: 24px;
    height: 24px;
    margin: 0 3px;
    background-color: #c2c2c2;
    &:hover {
      background-color: color.adjust(#c2c2c2, $lightness: -5%);
    }
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
    a {
      display: block;
      &:hover {
        text-decoration: none;
      }
      &:after {
        font-family: 'fontello';
        color: #fff;
        text-align: center;
        display: block;
        font-size: 17px;
        margin-top: 1px;
      }
    }
    &.contact {
      margin-right: 15px;
      a:after {
        content: '\e805';
      }
    }
    &.g-plus a:after {
      content: '\e801';
      margin-top: 2px;
    }
    &.slideshare a:after {
      content: '\e802';
      font-size: 16px;
    }
    &.twitter a:after {
      content: '\e804';
      margin-top: 2px;
    }
    &.linkedin a:after {
      content: '\e800';
    }
    &.pinterest a:after {
      content: '\e803';
      margin-top: 2px;
    }
  }
}
.user-navigation {
  margin: 0 0 5px 0;
  padding-right: 0;
  .separator {
    &:before {
      content: '|';
      margin: 0 15px;
      color: #f79939;
      font-size: 20px;
      vertical-align: -3px;
    }
  }
}
.dropdown {
  .btn {
    color: #474747;
    &:after {
      position: relative;
      top: 2px;
      transform: rotate(0);
      transition: all 0.3s ease;
      margin-left: 8px;
    }
  }
  &.show {
    .btn {
      &:after {
        transform: rotate(180deg);
      }
    }
  }
}
@media screen and (max-width: 1024px) {
  .main-header {
    .logo {
      margin: 16px 0;
      max-width: 200px;
    }
    .main-menu {
      li {
        margin: 0 15px;
      }
    }
    .user-navigation {
      padding: 0;
    }
  }
}
@media screen and (max-width: 767px) {
  #app {
    padding-top: 62px;
  }
  .mobile-header {
    position: relative;
    z-index: 20;
    .search {
      .search-input-wrap {
        min-width: 200px;
      }
      .search-button {
        min-width: 120px;
      }
    }

    .menu {
      border: 0;
      appearance: none;
      background: none;
      .open {
        display: flex;
        width: 21px;
        height: 14px;
        margin-top: 4px;
      }
      .close {
        margin-top: 4px;
        display: none;
        height: 14px;
        width: 21px;
      }
    }
  }
  .mobile-nav-open {
    .mobile-header {
      .menu {
        .open {
          display: none;
        }
        .close {
          display: flex;
        }
      }
    }
  }
  .main-header {
    position: fixed !important;
    height: 62px;
    top: 0;
    z-index: 9;
    border: none;
    background-color: #fff;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);
    img {
      margin: 12px 0;
    }
    .toggle-button {
      position: absolute;
      left: 0;
      top: 0;
      width: 62px;
      padding: 7px 0;
      background-color: #913d88;
      cursor: pointer;
      &-line {
        float: left;
        height: 8px;
        width: 38px;
        margin: 4px 12px;
        background-color: #ffffff;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .main-header {
    height: auto;
    .search-button {
      display: none;
    }
  }
}
</style>
